module.exports = __webpack_public_path__ + "img/618.89d96105.jpg";